import { Injectable } from '@angular/core';
import { FileType } from '@lsq-frontend/remote-services/enterprise/common';
import { DownloadService, FileExtensions } from '@lsq-frontend/common-ui';
import { UploadType } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { GetSuppliersUploadPresignedUrlService } from '@lsq-frontend/remote-services/all-java/financing-mk1-services';
import { GetSuppliersUploadTemplatePresignedUrlService } from '@lsq-frontend/remote-services/all-java/financing-mk1-services';

@Injectable({ providedIn: 'root' })
export class CreateSupplierService {
    constructor(
        private _getSuppliersUploadTemplatePresignedUrlService: GetSuppliersUploadTemplatePresignedUrlService,
        private _getSuppliersUploadPresignedUrlService: GetSuppliersUploadPresignedUrlService,
        private _downloadService: DownloadService
    ) {}

    public async downloadSuppliersUploadTemplate(): Promise<void> {
        const templateDownloadUrl = (
            await this._getSuppliersUploadTemplatePresignedUrlService.executeOnce({})
        ).presignedUrl;
        await this._downloadService.executeUrl(
            templateDownloadUrl,
            FileType.Csv,
            'Suppliers_Template'
        );
    }

    public async getSuppliersUploadPresignedUrl(buyerKey: string): Promise<string> {
        const uploadUrl = await this._getSuppliersUploadPresignedUrlService.executeOnce({
            buyerKey: buyerKey,
            fileExtension: FileExtensions.Csv,
            uploadType: UploadType.SUPPLIER
        });
        return uploadUrl.presignedUrl;
    }
}
